// name=src/components/MainMenu/MenuButtons.js
import React, { useCallback } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import styles from "./MainMenu.module.css";
import { resolveAccess } from "../../utils/access";

export default function MenuButtons({ controls, disabled, onFirstButtonRef }) {
  const navigate = useNavigate();

  const firstRefCb = useCallback(
    (node) => {
      if (node && onFirstButtonRef) onFirstButtonRef(node);
    },
    [onFirstButtonRef]
  );

  return (
    <div className={styles.buttons}>
      {(() => {
        let user = null;
        try { user = JSON.parse(localStorage.getItem('authUser') || 'null'); } catch {}
        const access = resolveAccess(user);

        const items = [];
        const addItem = (item) => {
          if (!items.some((x) => x.id === item.id)) items.push(item);
        };

        if (access.canAccess.tmc) addItem({ id: 'tmc', label: 'Справочник ТМЦ', href: '/tmc' });
        if (access.canAccess.tmcRequests) addItem({ id: 'tmc-requests', label: 'Заявки на ТМЦ', href: '/tmc-requests' });
        if (access.canAccess.warehouse) addItem({ id: 'warehouse', label: 'Склад', href: '/warehouse' });
        if (access.canAccess.cardCalc) addItem({ id: 'cards', label: 'Журнал карточек расчётов', href: '/card-calc' });
        if (access.canAccess.objects) addItem({ id: 'objects', label: 'Журнал объектов', href: '/objects' });
        if (access.canAccess.groups) addItem({ id: 'groups', label: 'Журнал групп', href: '/groups' });
        if (access.canAccess.supercontrol) addItem({ id: 'supercontrol', label: 'Суперконтроль', href: '/supercontrol' });
        if (access.canAccess.closingDocs) addItem({ id: 'closing-docs', label: 'Закрывающие документы', href: '/closing-docs' });
        if (access.canAccess.payrolls) addItem({ id: 'payrolls', label: 'Ведомости выплат', href: '/payrolls' });
        if (access.canAccess.positions) addItem({ id: 'positions', label: 'Должности', href: '/positions' });
        if (access.canAccess.adminUsers) addItem({ id: 'users-admin', label: 'Пользователи', href: '/admin/users' });
        if (access.canAccess.hr) addItem({ id: 'hr', label: 'Кадры', href: '/hr/employees' });

        if (access.techOnly || !items.length) {
          return (
            <div className={styles.restrictedNote}>
              <p>Доступ к разделам отсутствует для роли «Тех.персонал».</p>
              <p style={{ marginTop: 8 }}>Чтобы перейти в другую учетную запись, воспользуйтесь кнопкой «Выйти».</p>
            </div>
          );
        }

        return items.map((it, i) => (
        <motion.div
          key={it.id}
          initial={{ opacity: 0, y: 18, scale: 0.95 }}
          variants={{
            show: {
              opacity: 1,
              y: 0,
              scale: 1,
              transition: {
                duration: 0.36,
                ease: [0.34, 1.56, 0.64, 1],
                delay: i * 0.08
              },
            },
            instant: { opacity: 1, y: 0, scale: 1 },
          }}
          animate={controls}
        >
          <button
            type="button"
            className={styles.threedButton}
            tabIndex={disabled ? -1 : 0}
            ref={i === 0 ? firstRefCb : null}
            onClick={() => navigate(it.href)}
            aria-label={it.label}
          >
            <span>{it.label}</span>
          </button>
        </motion.div>
        ));
      })()}
    </div>
  );
}